import { Page } from 'pages/layout'

import { ShiftDetailHeader } from './ShiftDetailHeader'
import { ShiftDetailProvider } from './ShiftDetailProvider'
import { ShiftDetailContent } from './ShiftDetailContent'
import { useParams } from 'react-router-dom'
import { useAuthContext } from 'components/auth'

export function ShiftDetail() {
  const { companyId: companyIdParam, shiftId: shiftIdParam } = useParams<{
    companyId?: string
    shiftId: string
  }>()
  const { company } = useAuthContext()

  if (!shiftIdParam || !company) {
    return null
  }

  const companyId = companyIdParam ? Number(companyIdParam) : company.id

  return (
    <ShiftDetailProvider companyId={companyId} shiftId={Number(shiftIdParam)}>
      <Page>
        <ShiftDetailHeader />
        <ShiftDetailContent />
      </Page>
    </ShiftDetailProvider>
  )
}
